import api from '../api'

export default {
    namespaced: true,
    state: {
        JackpotList: [],
        date_log: '',// 彩池详情时间
        recordList: {// 玩家击中记录
            beanList: [],
            total: 0
        },
        userIntoRecordList: {// 玩家贡献记录
            beanList: [],
            total: 0
        },
        clubIntoRecordList: {// 俱乐部贡献记录
            beanList: [],
            total: 0
        },
        tribeIntoRecordList: {// 联盟贡献记录
            beanList: [],
            total: 0
        },
        userRecord: {// 玩家彩池
            nickNames: '',
            date: null,
            data:[]
        }
    },
    getters: {
        log_start: state => {
            return state.date_log[0] || ''
        },
        log_end: state => {
            return state.date_log[1] || ''
        }
    },
    mutations: {
        setStateJackpotList(state, info) {
            state.JackpotList = info
        },
        setStateDate(state, info) {
            state.date_log = info;
        },
        setStateRecordList(state, info) {
            state.recordList = info
        },
        setStateUserIntoRecordList(state, info) {
            state.userIntoRecordList = info
        },
        setStateClubIntoRecordList(state, info) {
            state.clubIntoRecordList = info
        },
        setStateTribeIntoRecordList(state, info) {
            state.tribeIntoRecordList = info
        },
        setStateUserRecord(state, {info,params}) {
            state.userRecord = Object.assign({},state.userRecord,{...info,...params})
        },

    },
    actions: {
        getJackpotList({commit}) {
            return api.post(`/jp/jpList`, 'jp配置列表').then(res => {
                commit('setStateJackpotList', res.data)
            })
        },
        updateJackpotRatio({dispatch}, params) {
            return api.post('/jp/setJpRatio', '修改jp牌型系数', params).then(() => {
                dispatch('getJackpotList')
            })
        },
        setJackpotChip({dispatch}, params) {
            return api.post('/jp/importJpPool', '注入jp彩池金豆', params).then(() => {
                dispatch('getJackpotList')
            })
        },
        getRecord({getters, commit}, page) {
            let params = {
                start: getters.log_start,
                end: getters.log_end,
                page: page,
                roomPath: '',
            };
            return api.post('/jp/record', '彩池击中记录', params).then(res => {
                commit('setStateRecordList', res.data)
            })
        },
        updatePumpApi({dispatch},pump){
            return api.post(`/jp/updatePamp/${pump}`,'更新彩金的服务费比例').then(()=>{
                dispatch('getJackpotList')
            })
        },
        getUserIntoRecord({getters, commit}, page) {
            let params = {
                start: getters.log_start,
                end: getters.log_end,
                page: page,
                roomPath: '',
            };
            return api.post('/jp/userIntoRecord', '玩家贡献记录', params).then(res => {
                commit('setStateUserIntoRecordList', res.data)
            })
        },
        getClubIntoRecord({getters, commit}, page) {
            let params = {
                start: getters.log_start,
                end: getters.log_end,
                page: page,
                roomPath: '',
            };
            return api.post('/jp/clubIntoRecord', '俱乐部贡献记录', params).then(res => {
                commit('setStateClubIntoRecordList', res.data)
            })
        },
        getTribeIntoRecord({getters, commit}, page) {
            let params = {
                start: getters.log_start,
                end: getters.log_end,
                page: page,
                roomPath: '',
            };
            return api.post('/jp/tribeIntoRecord', '联盟贡献记录', params).then(res => {
                commit('setStateTribeIntoRecordList', res.data)
            })
        },
        getUserRecord({commit}, params) {
            let data = {
                start: params.date[0],
                end: params.date[1],
                nickNames: params.nickNames.split(','),
            };
            return api.post('/jp/user/jpRecord', '玩家jp 查询', data).then(res => {
                commit('setStateUserRecord', {info:res,params})
            })
        },
    }
}